"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _dxcFlex = _interopRequireDefault(require("dxc-flex"));

var _animejs = _interopRequireDefault(require("animejs"));

var _is_js = _interopRequireDefault(require("is_js"));

require("../assets/index.css");

var _jsxFileName = "E:\\720\\720yun_tour_player\\src\\components\\pano-notice-bar\\src\\NoticeBar.js";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function randomId(prefix) {
  if (prefix === void 0) {
    prefix = "r_";
  }

  var code = Math.random().toString(36).substr(-8);
  return "" + prefix + code;
}

var NoticeBar = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(NoticeBar, _React$PureComponent);

  function NoticeBar() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "isPlay", true);

    _defineProperty(_assertThisInitialized(_this), "classId", randomId());

    _defineProperty(_assertThisInitialized(_this), "initScroll", function () {
      _animejs["default"].remove("." + _this.classId);

      var _this$props = _this.props,
          _this$props$rollingMo = _this$props.rollingMode,
          rollingMode = _this$props$rollingMo === void 0 ? 1 : _this$props$rollingMo,
          _this$props$speed = _this$props.speed,
          speed = _this$props$speed === void 0 ? 60 : _this$props$speed,
          _this$props$loop = _this$props.loop,
          loop = _this$props$loop === void 0 ? true : _this$props$loop,
          _this$props$isPlay = _this$props.isPlay,
          isPlay = _this$props$isPlay === void 0 ? true : _this$props$isPlay;

      _this.initTranslateX();

      if (speed === 0 || !isPlay) {
        return;
      }

      if (rollingMode === 0) {
        _this.initStatic();
      } else if (loop) {
        _this.initLoopScroll();
      } else {
        _this.initNoLoopScroll();
      } // this.initTranslateX();

    });

    _defineProperty(_assertThisInitialized(_this), "initTranslateX", function () {
      var width = _this.content.offsetWidth;
      var parentWidth = _this.content.parentNode.offsetWidth;
      if (width >= parentWidth) return;
      var initTranslateX; // const { rollingMode } = this.props;
      // if (rollingMode === 0) {
      //   initTranslateX = parseInt((parentWidth - width) / 2);
      // } else {
      //   initTranslateX = parseInt(parentWidth * 0.4);
      // }

      initTranslateX = parseInt((parentWidth - width) / 2);
      var dom = document.getElementsByClassName(_this.classId)[0];
      dom.style.transform = "translateX(" + initTranslateX + "px)";
    });

    _defineProperty(_assertThisInitialized(_this), "initDisable", function () {
      var width = _this.content.offsetWidth;
      var parentWidth = _this.content.parentNode.offsetWidth;
      var initTranslateX = parseInt((parentWidth - width) / 2);
      var dom = document.getElementsByClassName(_this.classId)[0];
      dom.style.transform = "translateX(" + initTranslateX + "px)";
    });

    _defineProperty(_assertThisInitialized(_this), "onComplete", function () {
      _this.isEnd = true;
      var onComplete = _this.props.onComplete;
      onComplete && onComplete();
    });

    _defineProperty(_assertThisInitialized(_this), "handlePause", function () {
      if (_this.isPlay && !_this.isEnd) {
        _this.noticeBarAnime.pause();

        _this.isPlay = false;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleTouchmove", function () {
      _this.handlePlay();
    });

    _defineProperty(_assertThisInitialized(_this), "handlePlay", function (e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      if (!_this.isPlay && !_this.isEnd) {
        _this.noticeBarAnime.play();

        document.body.removeEventListener("click", _this.handlePlay);
        document.body.removeEventListener("touchmove", _this.handleTouchmove);
        _this.isPlay = true;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function () {
      var _this$props$mouseEnte = _this.props.mouseEnterPause,
          mouseEnterPause = _this$props$mouseEnte === void 0 ? true : _this$props$mouseEnte;
      if (!mouseEnterPause) return;

      var isMobile = _is_js["default"].mobile();

      if (!isMobile) _this.handlePause();
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      var _this$props$mouseEnte2 = _this.props.mouseEnterPause,
          mouseEnterPause = _this$props$mouseEnte2 === void 0 ? true : _this$props$mouseEnte2;
      if (!mouseEnterPause) return;

      var isMobile = _is_js["default"].mobile();

      if (!isMobile) _this.handlePlay();
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      var url = _this.props.url;

      var isMobile = _is_js["default"].mobile();

      if (url || !isMobile) {
        return;
      } // e.preventDefault()
      // e.stopPropagation()


      if (_this.isPlay) {
        _this.handlePause();

        document.body.addEventListener("click", _this.handlePlay);
        document.body.addEventListener("touchmove", _this.handleTouchmove);
      } else {
        _this.handlePlay();
      }
    });

    return _this;
  }

  var _proto = NoticeBar.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.initScroll();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props2 = this.props,
        isPlay = _this$props2.isPlay,
        speed = _this$props2.speed,
        children = _this$props2.children,
        rollingMode = _this$props2.rollingMode;
    var prevIsPlay = prevProps.isPlay,
        prevSpeed = prevProps.speed,
        prevChildren = prevProps.children,
        prevRollingMode = prevProps.prevRollingMode;

    if (!isPlay && prevIsPlay) {
      _animejs["default"].remove("." + this.classId);
    }

    if (isPlay && !prevIsPlay) {
      this.initScroll();
    }

    if (speed !== prevSpeed) {
      this.initScroll();
    }

    if (children !== prevChildren) {
      this.initScroll();
    }

    if (rollingMode !== prevRollingMode) {
      this.initScroll();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.body.removeEventListener("click", this.handlePlay);
    document.body.removeEventListener("touchmove", this.handleTouchmove);

    _animejs["default"].remove("." + this.classId);
  };

  _proto.initLoopScroll = function initLoopScroll() {
    this.isEnd = false;
    var width = this.content.offsetWidth;
    var parentWidth = this.content.parentNode.offsetWidth; // const initTranslateX = parseInt(parentWidth * 0.4);

    var initTranslateX = parseInt((parentWidth - width) / 2);
    var _this$props$speed2 = this.props.speed,
        speed = _this$props$speed2 === void 0 ? 60 : _this$props$speed2;
    this.noticeBarAnime = (0, _animejs["default"])({
      targets: "." + this.classId,
      translateX: [{
        value: initTranslateX,
        duration: 0
      }, {
        value: -width,
        duration: (width + initTranslateX) / speed * 1000
      }, {
        value: parentWidth,
        duration: 0
      }, {
        value: initTranslateX,
        duration: (parentWidth - initTranslateX) / speed * 1000
      }],
      elasticity: 2000,
      easing: "linear",
      loop: true
    });
    return;
  };

  _proto.initNoLoopScroll = function initNoLoopScroll() {
    this.isEnd = false;
    var width = this.content.offsetWidth;
    var parentWidth = this.content.parentNode.offsetWidth;
    var initTranslateX = parseInt((parentWidth - width) / 2);
    var _this$props3 = this.props,
        _this$props3$speed = _this$props3.speed,
        speed = _this$props3$speed === void 0 ? 60 : _this$props3$speed,
        _this$props3$endDelay = _this$props3.endDelay,
        endDelay = _this$props3$endDelay === void 0 ? 0 : _this$props3$endDelay,
        _this$props3$startDel = _this$props3.startDelay,
        startDelay = _this$props3$startDel === void 0 ? 800 : _this$props3$startDel; // const totalWidth = width + initTranslateX
    // const duration = (totalWidth / speed) * 1000

    this.noticeBarAnime = (0, _animejs["default"])({
      targets: "." + this.classId,
      translateX: [{
        value: initTranslateX,
        duration: 0
      }, {
        value: -width,
        duration: (width + initTranslateX) / speed * 1000
      }, {
        value: -width,
        duration: endDelay
      }],
      elasticity: 2000,
      easing: "linear",
      loop: false,
      complete: this.onComplete,
      delay: startDelay
    });
    return;
  };

  _proto.initStatic = function initStatic() {
    this.isEnd = false;
    var width = this.content.offsetWidth;
    var parentWidth = this.content.parentNode.offsetWidth; // const initTranslateX = parseInt(parentWidth * 0.4);

    var initTranslateX = parseInt((parentWidth - width) / 2);
    var _this$props4 = this.props,
        _this$props4$endDelay = _this$props4.endDelay,
        endDelay = _this$props4$endDelay === void 0 ? 0 : _this$props4$endDelay,
        _this$props4$startDel = _this$props4.startDelay,
        startDelay = _this$props4$startDel === void 0 ? 800 : _this$props4$startDel;
    this.noticeBarAnime = (0, _animejs["default"])({
      targets: "." + this.classId,
      translateX: [{
        value: initTranslateX,
        duration: endDelay
      }],
      loop: false,
      complete: this.onComplete,
      delay: startDelay
    });
    return;
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props5 = this.props,
        url = _this$props5.url,
        target = _this$props5.target,
        style = _this$props5.style,
        className = _this$props5.className,
        color = _this$props5.color,
        onClick = _this$props5.onClick,
        isPointer = _this$props5.isPointer;
    return /*#__PURE__*/_react["default"].createElement(_dxcFlex["default"], {
      onClick: this.handleClick,
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave,
      vertical: "center",
      style: style,
      className: "pano-notice-bar " + className,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 205,
        columnNumber: 7
      }
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: url === "" ? null : url,
      ref: function ref(content) {
        return _this2.content = content;
      },
      className: "pano-notice-bar-content " + this.classId,
      target: target,
      style: {
        color: color,
        cursor: isPointer ? "pointer" : "auto"
      },
      onClick: onClick,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 213,
        columnNumber: 9
      }
    }, this.props.children));
  };

  return NoticeBar;
}(_react["default"].PureComponent);

exports["default"] = NoticeBar;
module.exports = exports.default;